import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckIconEmployer = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 54,
	viewBox: "0 0 72 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M22.2917 43.0833L7.0305 27.8222C5.86186 26.6535 3.96814 26.6502 2.79537 27.8147L1.13634 29.462C-0.0423048 30.6324 -0.0456719 32.5377 1.12883 33.7122L20.1703 52.7537C21.3419 53.9252 23.2414 53.9253 24.413 52.7537L70.1703 6.99632C71.3419 5.82475 71.3419 3.92525 70.1703 2.75368L68.537 1.12032C67.3658 -0.0508628 65.4671 -0.0513117 64.2953 1.11932L22.2917 43.0833Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgCheckIconEmployer);
export { ForwardRef as ReactComponent };
